import { MDBCol, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { useContext } from 'react';
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import { getNativeLanguageCodes } from "../../../utils/getNativeLanguageCodes";

export default function CssfLanguagesSkillsSection() {

    const { translations, displayLanguage } = useContext( TranslationContext );
    const { languageSkills } = useResumeDocumentSection();

    const nativeLanguageCodes = getNativeLanguageCodes( languageSkills );

    return (
        <>
            <MDBRow>
                <MDBCol md="3" className="header-cv" style={ {
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end",
                    color: "#009999",
                    fontSize: "14px"
                } }>
                    <span className="fw-bold" style={ { textAlign: "end" } }>
                        LANGUES
                    </span>
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "end" } }>
                    <hr style={ {
                        width: "95%",
                        margin: "0px",
                        height: "8px",
                        color: "#009999",
                        marginBottom: "8px",
                        opacity: "1"
                    } }/>
                </MDBCol>
            </MDBRow>
            <div className="preview">
                <MDBRow style={ { marginTop: "10px" } }>
                    <MDBCol md="3" className="header-cv" style={ {
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "start",
                        color: "#009999",
                        fontSize: "14px",
                        flexDirection: "column",
                        gap: "5px"
                    } }>
                        <span style={ { textAlign: "end", fontSize: "14px" } }>
                            { translations.pdf.nativeLanguagesLabel }
                        </span>
                        <span style={ { textAlign: "end", fontSize: "14px" } }>
                            { translations.pdf.otherLanguagesLabel }
                        </span>
                        <div style={ { minHeight: "20px" } }></div>
                        { languageSkills
                            .filter( skill => skill.language )
                            .filter( skill => !nativeLanguageCodes.includes( skill.language?.code ) )
                            .sort( ( a, b ) => a.order - b.order )
                            .map( ( skill, index ) => (
                                <span key={ index }
                                      style={ { textAlign: "end", fontSize: "14px", color: "#4f4f4f" } }>
                                    { skill.language?.translations?.[ displayLanguage ] }
                                </span>
                            ) ) }
                    </MDBCol>
                    <MDBCol md="9" className="text-start"
                            style={ { display: "flex", alignItems: "start", flexDirection: "column", gap: "5px" } }>
                        <span className="fw-bold" style={ { textAlign: "end", fontSize: "14px" } }>
                            { languageSkills
                                .filter( skill => skill.language )
                                .filter( skill => nativeLanguageCodes.includes( skill.language.code ) )
                                .sort( ( a, b ) => a.order - b.order )
                                .map( skill => skill.language.translations?.[ displayLanguage ] )
                                .join( ", " ) }
                        </span>
                        <MDBTable style={ { fontSize: "11px", width: "96%" } }>
                            <MDBTableHead>
                                <tr className="text-center" style={ { borderTop: "1px solid #dee2e6" } }>
                                    <th colSpan="2" className="p-1"
                                        style={ {
                                            color: "#009999",
                                            borderRight: "1px solid #dee2e6"
                                        } }>
                                        COMPRENDRE
                                    </th>
                                    <th colSpan="2" className="p-1"
                                        style={ {
                                            color: "#009999",
                                            borderRight: "1px solid #dee2e6"
                                        } }>
                                        PARLER
                                    </th>
                                    <th className="p-1"
                                        style={ {
                                            color: "#009999",
                                        } }>
                                        ÉCRIRE
                                    </th>
                                </tr>

                                <tr className="text-black">
                                    <th className="text-center p-1" style={ {
                                        width: "15%",
                                        borderRight: "1px solid #dee2e6",
                                        color: "#009999"
                                    } }>Écouter
                                    </th>
                                    <th className="text-center p-1" style={ {
                                        width: "15%",
                                        borderRight: "1px solid #dee2e6",
                                        color: "#009999"
                                    } }>Lire
                                    </th>
                                    <th className="text-center p-1" style={ {
                                        width: "20%",
                                        borderRight: "1px solid #dee2e6",
                                        color: "#009999"
                                    } }>Prendre part à une conversation
                                    </th>
                                    <th className="text-center p-1" style={ {
                                        width: "20%",
                                        borderRight: "1px solid #dee2e6",
                                        color: "#009999"
                                    } }>S’exprimer oralement en continu
                                    </th>
                                    <th className="text-center p-1" style={ { width: "10%" } }></th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody style={ { verticalAlign: 'middle' } }>
                                { languageSkills
                                    .filter( skill => skill.language )
                                    .filter( skill => !nativeLanguageCodes.includes( skill.language.code ) )
                                    .sort( ( a, b ) => a.order - b.order )
                                    .map( ( languageSkill, index ) => (
                                        <tr key={ index } className='text-black'>
                                            <td className="text-center p-1">
                                                <p className="p-0 m-0">
                                                    { languageSkill.listeningComprehensionLevel?.translations?.[ displayLanguage ] }
                                                </p>
                                            </td>
                                            <td className="text-center p-1">
                                                <p className="p-0 m-0">
                                                    { languageSkill.readingComprehensionLevel?.translations?.[ displayLanguage ] }
                                                </p>
                                            </td>
                                            <td className="text-center p-1">
                                                <p className="p-0 m-0">
                                                    { languageSkill.oralInteractionLevel?.translations?.[ displayLanguage ] }
                                                </p>
                                            </td>
                                            <td className="text-center p-1">
                                                <p className="p-0 m-0">
                                                    { languageSkill.continuousOralExpressionLevel?.translations?.[ displayLanguage ] }
                                                </p>
                                            </td>
                                            <td className="text-center p-1">
                                                <p className="p-0 m-0">
                                                    { languageSkill.writingExpressionLevel?.translations?.[ displayLanguage ] }
                                                </p>
                                            </td>
                                        </tr>
                                    ) ) }
                            </MDBTableBody>
                        </MDBTable>
                    </MDBCol>
                </MDBRow>
            </div>
        </>
    );
};
